/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SpoSearchCriteriaService} from '../../spo/services/spo-search-criteria.service';
import {ClaimSearchCriteriaService} from '../../claim/services/claim-search-criteria.service';
import {PartNumberChangesSearchCriteriaService} from '../../part-number-changes/services/part-number-changes-search-criteria.service';
import {SettlementSearchCriteriaService} from '../../settlements/services/settlement-search-criteria.service';

export abstract class AbstractSideBarMenuComponent {

    protected constructor(protected spoSearchCriteriaService: SpoSearchCriteriaService,
                          protected claimSearchCriteriaService: ClaimSearchCriteriaService,
                          protected partNumberChangesCriteriaService: PartNumberChangesSearchCriteriaService,
                          protected settlementSearchCriteriaService: SettlementSearchCriteriaService) {
    }

    /**
     * Every changes on side bar should clear all cached filters
     */
    changeContext(): void {
        this.spoSearchCriteriaService.clear();
        this.claimSearchCriteriaService.clear();
        this.partNumberChangesCriteriaService.clear();
        this.settlementSearchCriteriaService.clear();
    }
}
